module.exports = __webpack_public_path__ + "img/Location.94a8a9c3.svg";